import {React, useContext, useState} from 'react'
import { Formik, useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import { CartContext } from '../../Context/CartContext';
import { Helmet } from 'react-helmet';
export default function Login() {
  let [isLoading, setIsLoading] = useState(false);
  const [messageError,setMessageError] = useState("");
  let {saveUserData} = useContext(CartContext)
  let navigate = useNavigate();
  function handleLogin(values) {
    setIsLoading(true);
    axios.post(`https://ecommerce.routemisr.com/api/v1/auth/signin`, values)
    .then(({ data }) => {
        console.log(data);
        if (data.message === 'success') {
            localStorage.setItem("userToken", data.token);

            saveUserData(); // This updates the state in the parent component
            setIsLoading(false);
            
            navigate("/", { replace: true });

            // Re-render the app immediately after login
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    })
    .catch((error) => {
        setIsLoading(false);
        console.log(error.response?.data);
        setMessageError(`${error.response?.data?.statusMsg}: ${error.response?.data?.message}`);
    });
}


  let validation = Yup.object({
    email: Yup.string().required('email is required').email("email not valid"),
    password: Yup.string().required('password is required').matches(/^[A-Z][a-z0-9]{5,10}$/ ,"password must match"),
  })
  let formik = useFormik({
    initialValues:{
      "email": "",
      "password": "",
    },
    validationSchema: validation,
    onSubmit:handleLogin
  })
  return (
    <>
    <Helmet>
      <title>Login</title>
    </Helmet>
      <div className="w-75 mt-5">
          <h3>Login</h3>
        {messageError.length > 0 ? <div className="alert alert-danger">{messageError}</div> : null}
        <form onSubmit={formik.handleSubmit} >

          <label htmlFor="email">Email:</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.email} type="email" name="email" id="email" />
          {formik.errors.email && formik.touched.email ?<div className="alert alert-danger">{formik.errors.email}</div> : null}

          <label htmlFor="password">Password</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.password} type="password" name="password" id="password" />
          {formik.errors.password && formik.touched.password ?<div className="alert alert-danger">{formik.errors.password}</div> : null}

          {/* forget password */}
          <NavLink to={"/forgetpassword"} ><p className='text-main'>Forget Password?</p></NavLink>

          {/* btn login */}
          {isLoading? <button type='button' className='btn bg-success  text-white'><i className='fas fa-spinner fa-spin'></i></button> : <button disabled={!(formik.isValid && formik.dirty)} type='submit' className='btn bg-success  text-white'>Login</button>}
        </form>
      </div>
    </>
  )
}
